import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react'

const testimonials = [
  {
    id: 1,
    name: '18NotOut Team',
    role: 'NGO Event',
    content: 'Dr. Sophia\'s you rocked the event with your performace. It a critical part to make people move around.. You are gifted and may God bless you more and more.',
    rating: 5,
    image: '👩‍👧‍👦',
    age: 'Organizer',
    location: 'Bangalore'
  },
  {
    id: 2,
    name: 'Event team',
    role: 'Inclusive Independence Day',
    content: 'Sophie mam you created magic at the event. Thanks a ton for the gracing the occasion, the way you chreographed was amazing.',
    rating: 5,
    image: '👨‍👩‍👧‍👦',
    age: 'Event',
    location: 'Bangalore'
  },
  {
    id: 3,
    name: 'Student',
    role: 'Online Ladies Dance Class',
    content: 'It was a wonderfull session Mam. you are giving hopes to lazy people like me, who are passionate about dance but do not shake and dance. Loved your simling face and energy. Renaming you as our Chocolaty Girl.',
    rating: 5,
    image: '👩',
    age: 'Student',
    location: 'Online'
  },
  {
    id: 4,
    name: 'Participant',
    role: 'Phoniex mall of asia event',
    content: 'I loved your expression in the event and giving us encouragement to dance. It says it all, thank you so much for your moves and guidance.',
    rating: 5,
    image: '👩',
    age: 'Organizer',
    location: 'Bangalore'
  },
  {
    id: 5,
    name: 'Participant',
    role: 'Dance Student',
    content: 'Zumba is the higlight of today\'s event. She was was awesome and the she pull the crowd and match their enery was commendable. Fun Filled session.',
    rating: 5,
    image: '💃',
    age: 'Organizer',
    location: 'Bangalore'
  },
  {
    id: 6,
    name: 'Parent',
    role: 'Art Class Student',
    content: 'Best teacher or mentor once can ask for and the way you teach is amazing. It\'s so cute to see my child enjoying.',
    rating: 5,
    image: '👨',
    age: 'Student',
    location: 'Bangalore'
  },
  {
    id: 7,
    name: 'Parent',
    role: 'Special children dance class',
    content: 'The special children dance class has given my child a safe space to express and learn at her own pace. Thanks a ton for bringing joy to my angel.',
    rating: 5,
    image: '👩‍🦱',
    age: 'Student',
    location: 'Online'
  },
  {
    id: 8,
    name: 'Parent',
    role: 'Special children dance class',
    content: 'Our Child enjoyed the dance class very much today, she usually takes time to warm up to new people, but with Sophia mam i see her getting used to now. She was very responsive too. I am soo happy to witness all this.',
    rating: 5,
    image: '👨‍👩‍👧',
    age: 'Student',
    location: 'Online'
  },
  {
    id: 9,
    name: 'Student',
    role: 'Kids Class Student',
    content: 'Thank you Sophia, you truly are a gifted people and wonderfull soul.',
    rating: 5,
    image: '👩',
    age: 'Parents',
    location: 'Online'
  }
]

export default function TestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length)
    }, 5000) // Change every 5 seconds

    return () => clearInterval(interval)
  }, [isAutoPlaying])

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length)
    setIsAutoPlaying(false) // Stop auto-play when user manually navigates
  }

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1))
    setIsAutoPlaying(false) // Stop auto-play when user manually navigates
  }

  const goToTestimonial = (index: number) => {
    setCurrentIndex(index)
    setIsAutoPlaying(false) // Stop auto-play when user manually navigates
  }

  const currentTestimonial = testimonials[currentIndex]

  return (
    <div className="relative bg-gradient-to-br from-primary-50 to-secondary-50 dark:from-gray-800 dark:to-gray-700 py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            What Our <span className="gradient-text">Students Say</span>
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our amazing students and their families have to say about their dance journey with Dr. Sophia.
          </p>
        </motion.div>

        {/* Testimonial Slider */}
        <div className="relative max-w-4xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-white dark:bg-gray-800 shadow-xl">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentIndex}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.5 }}
                className="p-8 md:p-12"
              >
                <div className="text-center">
                  {/* Quote Icon */}
                  <div className="mb-6">
                    <Quote className="w-12 h-12 text-primary-200 dark:text-primary-400 mx-auto" />
                  </div>

                  {/* Testimonial Content */}
                  <blockquote className="text-lg md:text-xl text-gray-700 dark:text-gray-300 mb-8 leading-relaxed">
                    "{currentTestimonial.content}"
                  </blockquote>

                  {/* Rating */}
                  <div className="flex justify-center mb-6">
                    {[...Array(currentTestimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                    ))}
                  </div>

                  {/* Author Info */}
                  <div className="flex items-center justify-center gap-4">
                    <div className="w-16 h-16 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full flex items-center justify-center text-2xl">
                      {currentTestimonial.image}
                    </div>
                    <div className="text-left">
                      <h4 className="text-xl font-semibold text-gray-900 dark:text-white">
                        {currentTestimonial.name}
                      </h4>
                      <p className="text-gray-600 dark:text-gray-400">
                        {currentTestimonial.role}
                      </p>
                      <p className="text-sm text-gray-500 dark:text-gray-500">
                        {currentTestimonial.location} • Age: {currentTestimonial.age}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>

            {/* Navigation Arrows */}
            <button
              onClick={prevTestimonial}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 p-3 bg-white dark:bg-gray-700 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
            >
              <ChevronLeft className="w-6 h-6 text-gray-600 dark:text-gray-300" />
            </button>

            <button
              onClick={nextTestimonial}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 p-3 bg-white dark:bg-gray-700 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
            >
              <ChevronRight className="w-6 h-6 text-gray-600 dark:text-gray-300" />
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-primary-600 scale-125'
                    : 'bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500'
                }`}
              />
            ))}
          </div>

        </div>

      </div>
    </div>
  )
}
